import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import MarketplaceListItem from './marketplace-list-item';
import { useScreenSizeContext } from '../../../../contexts/screen-size-resolution';

import style from './marketplace-list.module.less';
import messages from './messages';

const STORES_PER_ROW_NOT_TABLET = 5;
const STORES_PER_ROW_TABLET = 4;

export const MarketplaceList = ({ items, openMarketplaceModal, onClickAddStore }) => {
  const { isTablet } = useScreenSizeContext() || {};
  const numberOfStoresPerRow = isTablet ? STORES_PER_ROW_TABLET : STORES_PER_ROW_NOT_TABLET;
  const isLongList = items.length > numberOfStoresPerRow;
  const [isTruncated, setIsTruncated] = useState(true);
  const itemsToRender = isLongList && isTruncated ? items.slice(0, numberOfStoresPerRow) : items;
  return (
    <>
      <div className={style['marketplace-list']}>
        {itemsToRender.map((item) => (
          <MarketplaceListItem key={item.id} item={item} onClickAddStore={onClickAddStore} openMarketplaceModal={openMarketplaceModal} />
        ))}
      </div>
      {isTruncated && isLongList && (
        <div className={style['expand-button-wrapper']}>
          <Button onClick={() => setIsTruncated(false)} theme='link'>
            <FormattedMessage {...messages.viewMore} />
          </Button>
        </div>
      )}
    </>
  );
};

MarketplaceList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  openMarketplaceModal: PropTypes.func.isRequired,
  onClickAddStore: PropTypes.func.isRequired,
};
